<header class="mast-main-head fixed-top" *ngIf="mobileViewSection">
  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container left-header-subscribe">
      <a class="navbar-brand js-scroll-trigger" routerLink="/home"><img src="assets/img/logo.svg"></a>
    </div>
  </nav>
</header>

<header class="masthead" *ngIf="!mobileViewSection">
	<div class="navbar">
		<div class="left-header" style="margin-left: 12px; width: 500px;">
				<button style="width: 260px;" id="create-workspace" class="back-to-workspace" data-toggle="dropdown" class="DAM-icon">
					<a *ngIf="currentUser" (click)="backToWorkspace()" class="navbar-brand js-scroll-trigger left-header-backpress" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					    <title>Back</title>
					    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					        <g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
					            <g id="Back" transform="translate(40.000000, 28.000000)">
					                <rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
					                <g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
					                    <line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
					                    <polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
					                </g>
					            </g>
					        </g>
					    </g>
					</svg>
				</a>
				<div class="lib-icon-blue">
					<img src="assets/img/user-profile.svg">
				</div>
				<!-- <h4 class="content-lib-txt">{{userMainName}}</h4> -->
        <img style="margin-left: 16px;" src="assets/img/Logo-blue.svg">
			</button>
		</div>

		<div class="right-header" style="width: 500px;">

      <div class="figma-icons-section">
        <div class="plugin-figma-icon">
          <button (click)="openFigma()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-figma.png">
          </button>
        </div>

        <div class="plugin-sketch-icon">
          <button (click)="openSketch()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-sketch.png">
          </button>
        </div>

        <div class="plugin-ai-icon">
          <button (click)="openIllustrator()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ai.png" style="width: 20px; height: 20px;">
          </button>
        </div>
      </div>

			<a *ngIf="!currentUser && !mobileView" class="nav-link button" data-toggle="modal" (click)="openLoginScreen()" data-target="#signup-popup" style="background: #DEEBFF; color: #2d7cff; width: 160px; margin-left: 24px; cursor: pointer;">Start for Free</a>

			<div class="menu-pop-over user-name" *ngIf="currentUser && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
						<img *ngIf="!userPic" src="assets/img/user-profile.svg">
						<img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
							</div>
							<div class="email">{{currentUser.email}}</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
              <div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
              <div class="hr-line"></div>
              <a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a (click)="goToFeedback()"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
              <a (click)="goToSubscription()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section class="mobile-view-section" *ngIf="mobileViewSection">
	<div class="container">
		<div class="row">
		  <img src="assets/img/laptop.svg" alt="">
		  <div class="text-container">
		    <h4>Switch to Desktop</h4>
		    <p>Crafttor Workspace is best experienced on desktop. To proceed, Log in from a desktop browser.</p>
		  </div>
		</div>
	</div>
</section>

<section class="my-profile-section" *ngIf="profileSection">
	<div class="container">
		<div class="row">

      <div class="col-sm-6">
				<div class="img-box">
          <img style="background: #f6f9fe; border-radius: 50%;" *ngIf="!userMainPic" class="user-img" src="assets/img/user-profile.svg">
          <img *ngIf="userMainPic" class="public-user-img" src="{{userMainPic}}">
				</div>
			</div>

      <div class="col-sm-6">
				<div class="inner-content">
          <div class="public-user-name-details">
            <h2>{{userMainName}}</h2>

            <!-- <div class="rating-follow-sec">
              <div class="star-rating">
                <ul>
                  <li *ngFor="let star of stars"><img src="{{ starState(star) }}" alt="star" /></li>
                </ul>
              </div>

              <button type="button" name="button" class="border-blue-btn">Follow</button>
            </div> -->
          </div>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="public-profile-tabs" *ngIf="profileSection">
	<div class="container">
		<div class="row">
			<div class="col-sm-12">
				<div class="profile-options">
					<h4 [ngClass]="{'selected-text': isSelected[0], 'unselected-text': !isSelected[0]}" (click)="projectsClick(0)">Projects</h4>

					<!-- <h4 [ngClass]="{'selected-text': isSelected[2], 'unselected-text': !isSelected[2]}" (click)="follwoingClick(2)">Following</h4> -->

          <!-- <h4 [ngClass]="{'selected-text': isSelected[1], 'unselected-text': !isSelected[1]}" (click)="ratingClick(1)">Rating</h4> -->

					<h4 [ngClass]="{'selected-text': isSelected[2], 'unselected-text': !isSelected[2]}" (click)="aboutClick(2)">About</h4>
				</div>

				<hr>

				<div class="all-profile-coverage">

					<!-- <div class="my-projects" *ngIf="showMyProjects">

						<div class="no-illus-img">
							<img src="assets/img/empty_file_img.svg">
							<div><label>No projects added.</label></div>
						</div>
					</div> -->

          <div class="my-projects" *ngIf="showMyUploads && !showProjects">
						<div class="add-new-projects" style="margin-left: auto; margin-right: auto;">
							<h6>Projects hidden by User.</h6>
						</div>
					</div>

					<div class="illus-rollup-view row mb-5 mt-2" *ngIf="showMyUploads && showProjects">
						<ul class="new-board-media-list" *ngFor="let uploads of myUploadsImagesList; let i = index;">
							<li>
								<div class="inner-card">
									<div class="illus-img-container" data-toggle="modal">

										<video src={{uploads.image}} *ngIf="uploads.image_format == 'MP4' || uploads.image_format == 'WMV' || uploads.image_format == 'MOV' || uploads.image_format == 'FLV' || uploads.image_format == 'WEBM'" style="height: 210px; width: 240px; max-height: 300px; max-width: 300px;" controls (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);"></video>

										<img src={{uploads.image}} *ngIf="uploads.image_format == 'PNG' || uploads.image_format == 'JPG'  ||uploads.image_format == 'SVG' || uploads.image_format == 'JPEG' || uploads.image_format == 'GIF'  || uploads.image_format == 'BMP'" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

										<img src={{uploads.image_jpg}} *ngIf="uploads.image_format == 'WEBP' || uploads.image_format == 'TIFF'" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

										<img src="assets/img/eps-icon.svg" *ngIf="uploads.image_format == 'EPS'" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

										<img src="assets/img/ai-icon.svg" *ngIf="uploads.image_format == 'AI'" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

										<img src="assets/img/zip-icon.svg" *ngIf="uploads.image_format == 'ZIP'" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

										<img src="assets/img/xlsx-ixon.svg" *ngIf="uploads.image_format == 'XLSX'" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

										<img src="assets/img/doc-icon.svg" *ngIf="uploads.image_format == 'DOCX' || uploads.image_format == 'DOC'" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

										<img src="assets/img/psd.svg" *ngIf="uploads.image_format == 'PSD'" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

										<pdf-viewer style="height: 210px; width: 240px; max-height: 300px; max-width: 300px;" *ngIf="uploads.image_format == 'PDF'" [src]="uploads.image" [original-size]="true" [render-text]="true" [rotation]="0"
										[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
										[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
										[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);"></pdf-viewer>

									</div>

									<div class="hover-style">
										<div class="title" style="text-align: start;"><b>{{ uploads.title }}</b>
											<br>
											<span *ngIf="uploads.size > 1000">{{uploads.image_format}} - {{ uploads.size/1000 }} MB</span>
											<span *ngIf="uploads.size < 1000">{{uploads.image_format}} - {{ uploads.size }} KB</span>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>

					<div class="profile-followers-area" *ngIf="showMyFollowers">

						<div class="search-user-section">
							<form class="custom-form" (ngSubmit)="onSubmitUser()">
								<div class="side-search-box">
									<div class="search-box-side-bar" id="search-box" style="box-shadow: none; width: 140%;">
										<button>
											<span role="img" aria-label="search" class=""><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="search" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg></span>
										</button>
										<input type="" name="searchUser" placeholder="Search user" [(ngModel)]="searchUser">
										<input style="display: none" type="Submit" value="Search" class="button">
									</div>
								</div>
							</form>

							<div class="filter-section">
								<span data-toggle="dropdown"><img style="width: 18px; margin-right: 6px" src="assets/img/filter.svg" alt="">Filter</span>

								<div class="dropdown-menu images-drop-down" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
									 <ul class="list-group">
											<li class="more-option-section">
											 <a class="text" href="javscript:;" style="color:#000">❤️ <span style="margin-left: 8px;">Heart rated</span></a>
										 </li>

										 <li class="more-option-section">
											 <a class="text" href="javscript:;" style="color:#000">❤️ <span style="margin-left: 8px;">Star rated</span></a>
										 </li>
									 </ul>
								 </div>
							</div>
						</div>

						<div class="images-table-section">
							<table class="table-view-section">
								<tr>
									<th>Name</th>
									<th>User Id</th>
									<th>Reward</th>
									<th>Follow</th>
								</tr>
								<tr>
									<td class="table-size-text">Akash Bariar</td>
									<td class="table-size-text">abariar-0013</td>
									<td class="table-size-text">❤️</td>
									<td class="table-size-text">Follow</td>
								</tr>
								<tr>
									<td class="table-size-text">Akash Bariar</td>
									<td class="table-size-text">abariar-0013</td>
									<td class="table-size-text">❤️</td>
									<td class="table-size-text">Follow</td>
								</tr>
								<tr>
									<td class="table-size-text">Akash Bariar</td>
									<td class="table-size-text">abariar-0013</td>
									<td class="table-size-text">❤️</td>
									<td class="table-size-text">Follow</td>
								</tr>
							</table>
						</div>
					</div>

          <div class="show-more-area" *ngIf="showRatings">

            <div class="container">
              <div class="row" style="margin-top: 60px;">
                <div class="col-sm-6">
                  <div class="public-all-social-icons">
                    <h2 style="text-align: left;">User ratings</h2>
                    <div class="star-rating">
                      <ul class="ratings-list">
                        <li *ngFor="let star of stars"><img src="{{ starState(star) }}" alt="star" /></li>
                      </ul>
                    </div>

                    <button class="btn" type="button" name="button">Submit</button>
    						  </div>
                </div>
              </div>
            </div>
					</div>

					<div class="show-more-area" *ngIf="showAbout">
            <div class="container">
              <div class="row" style="margin-top: 60px;">
                <div class="col-sm-6">
                  <div class="public-all-social-icons" *ngIf="showSocialHandles">
                    <h2 style="text-align: left;">Social Handles</h2>
    								<ul class="social-icons">
    									<li *ngIf="twitterLink"><a rel="nofollow" href="{{twitterLink}}" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true" style="color: #a9a9a9;"></i></a></li>
    									<li *ngIf="linkedinLink"><a rel="nofollow" href="{{linkedinLink}}" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true" style="color: #a9a9a9;"></i></a></li>
    									<li *ngIf="instagramLink"><a rel="nofollow" href="{{instagramLink}}" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true" style="color: #a9a9a9;"></i></a></li>
    									<li *ngIf="dribbbleLink"><a rel="nofollow" href="{{dribbbleLink}}" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true" style="color: #a9a9a9;"></i></a></li>
    									<li *ngIf="behanceLink"><a rel="nofollow" href="{{behanceLink}}" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true" style="color: #a9a9a9;"></i></a></li>
    								</ul>
    						  </div>
                </div>

                <div class="col-sm-6 bio-text-public-profile">
                  <div style="text-align: center;" class="about-title-location">
    					      <h2 class="add-bio">Bio</h2>
                    <p class="title-txt"><span>Title:</span>{{userTitle}}</p>
                    <p class="location-txt"><span>Location:</span>{{userLocation}}</p>
                    <p class="bio-txt"><span>Bio:</span>{{userBio}}</p>
    					    </div>

                  <!-- <div class="" style="display:flex; margin-top: 40px;">
                    <p>Followers <span>100</span></p>
                    <p style="margin-left: 32px;">Following <span>10</span></p>
                  </div> -->
                </div>

                <div class="col-12">
                  <hr class="profile-hr">
                </div>

                <!-- <div class="col-12 text-center">
                  <h3 class="profile-link-public">Profile link <svg viewBox="64 64 896 896" focusable="false" data-icon="appstore" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"></path></svg></h3>
                </div> -->
              </div>
            </div>
					</div>

					<div class="no-illus-img" *ngIf="showNoDataIllus">
						<img src="assets/img/empty_file_img.svg">
						<div><label>No uploads.</label></div>
					</div>
				</div>

				<div class="loader-scenarios" *ngIf="showTopRightLoader">
					<img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
				</div>

				<div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulMsg">
					<span class="ant-avatar-selected">
						<svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</span>
					<p>{{successfullMessage}}</p>
				</div>

				<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
					<p>{{sendSuccessfulErrorMessage}}</p>
				</div>

			</div>
		</div>
	</div>
</section>

<section class="url-expired-section" *ngIf="noDataSection">
	<div class="main-container">
		<div class="center-container">
			<div class="no-data-container">
        <div class="no-result-section">
  				<div class="no-data-img">
  					<img src="assets/img/no-exist.svg" style="width: 400px;">
  					<p>The page you are looking for is invalid or expired.</p>
  				</div>
  				<br />
  				<br />
  			</div>
		  </div>
	  </div>
  </div>
</section>

<ng-template #imgMainModal let-imgMainModal>
  <div class="modal-dialog modal-dialog-centered svg-modal" role="document">
    <div class="modal-content">
      <div class="modal-body d-flex">
        <div class="public-profile-svg-preview">
          <div class="modal-sep">
            <h4>{{currentIllus.title | slice:0:30}}{{currentIllus.title.length > 30 ? '...' : ''}}</h4>
            <img style="background: #f6f9fe; border-radius: 50%;" class="user-img" *ngIf="!userPic" src="assets/img/user-profile.svg">
						<img class="user-img" *ngIf="userPic" src="{{userPic}}">

            <a (click)="imgMainModal.close()" class="close-main-dialog">
              <svg width="24px" height="24px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
                    <g id="DAM-Landing-Page-Copy-3" transform="translate(-911.000000, -23.000000)">
                        <g id="Cross" transform="translate(912.000000, 24.000000)">
                            <rect id="Rectangle" x="0" y="0" width="24" height="24" rx="4"></rect>
                            <g id="Group-3" transform="translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" stroke="#000000" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="8" y1="0" x2="8" y2="16" id="Path-8"></line>
                                <line x1="8" y1="0.421052632" x2="8" y2="15.5789474" id="Path-8-Copy" transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "></line>
                            </g>
                        </g>
                    </g>
                </g>
              </svg>
            </a>

           <div class="svg-preview-container">
             <span *ngIf="myUploadsImagesList.length > 1 && showPreviousIcon" aria-hidden="true" (click)="previousImage(currentIllusPosition)" class="previos-icon">
               <svg style="background-color: #f5f6f7; border-radius: 40px; transform: rotate(180deg);" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
             </span>

            <pdf-viewer *ngIf="currentIllus.image_format == 'PDF'" [src]="currentIllus.image" [original-size]="true" [render-text]="true" [rotation]="0"
            [show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
            [stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
            [show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>

            <input type="checkbox" id="zoomCheck" style="display: none;">
              <label for="zoomCheck">
                <img src="assets/img/psd.svg" *ngIf="currentIllus.image_format == 'PSD'">

                <img [src]="currentIllus.image" alt="download illustrations" *ngIf="currentIllus.image_format == 'PNG' || currentIllus.image_format == 'JPG'  ||currentIllus.image_format == 'SVG' || currentIllus.image_format == 'JPEG' || currentIllus.image_format == 'GIF' || currentIllus.image_format == 'BMP'">

                <img [src]="currentIllus.image_jpg" *ngIf="currentIllus.image_format == 'WEBP' || currentIllus.image_format == 'TIFF'">

                <img src="assets/img/ai-icon.svg" *ngIf="currentIllus.image_format == 'AI'">

                <img src="assets/img/eps-icon.svg" *ngIf="currentIllus.image_format == 'EPS'">

                <img src="assets/img/zip-icon.svg" *ngIf="currentIllus.image_format == 'ZIP'">

                <img src="assets/img/doc-icon.svg" *ngIf="currentIllus.image_format == 'DOCX' || currentIllus.image_format == 'DOC'">

                <img src="assets/img/xlsx-icon.svg" *ngIf="currentIllus.image_format == 'XLSX'">
              </label>

              <video src={{currentIllus.image}} *ngIf="currentIllus.image_format == 'MP4' || currentIllus.image_format == 'WEBM' || currentIllus.image_format == 'FLV' || currentIllus.image_format == 'WMV' || currentIllus.image_format == 'MOV'" controls></video>

              <span *ngIf="myUploadsImagesList.length > 1 && showNextIcon" class="next-icon" aria-hidden="true" (click)="nextImage(currentIllusPosition)">
                <svg style="background-color: #f5f6f7; border-radius: 40px;" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
          </div>
        </div>
      </div>
      <hr>
     </div>
    </div>
  </div>
</ng-template>

<footer class="site-footer">
  <div class="container">
  <div class="row">
    <div class="col-sm-3">
      <div class="coulmn-1">
        <img src="assets/img/logo.svg">
        <p>Digital assets management</p>
        <a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
      </div>
    </div>
    <!-- 3 -->
    <div class="col-sm-2">
      <h5>Products</h5>
      <ul class="menu">
        <li><a>Workspace</a></li>
        <li><a (click)="openMarketplace()">Marketplace</a></li>
        <li><a routerLink="/features">Features</a></li>
        <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
<li><a routerLink="/smart-storage">Smart storage</a></li>
        <li><a routerLink="/effective-search">Effective search</a></li>

      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Plugins</h5>
      <ul class="menu">
        <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
        <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
        <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
        <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
        <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
        <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
        <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Solutions</h5>
      <ul class="menu">
        <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
        <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
        <li><a routerLink="/box-alternative">Box alternative</a></li>
        <li><a routerLink="/content-library">Content library</a></li>
        <li><a routerLink="/user-profiling">User Profiling</a></li>
<li><a routerLink="/approvals">Creative approvals</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Features</h5>
      <ul class="menu">
        <li><a routerLink="/features/tagging">Tagging</a></li>
        <li><a routerLink="/features/sharing">Sharing</a></li>
        <li><a routerLink="/features/versioning">Versioning</a></li>
        <li><a routerLink="/features/collaboration">Collaboration</a></li>
        <li><a routerLink="/features/integration">Integration</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Company</h5>
      <ul class="menu">
        <li><a routerLink="/about-workspace">About Workspace</a></li>
        <li><a routerLink="/contact">Contact Us</a></li>
        <li><a routerLink="/terms">Terms & Conditions</a></li>
        <li><a routerLink="/faq">FAQ</a></li>
        <li><a routerLink="/feedbacks">Feedback</a></li>
        <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
        <li><a routerLink="/our-mission">Our mission</a></li>
        <li><a routerLink="/partner-with-us">Partner with us</a></li>
      </ul>
    </div>

    <div class="col-sm-3 all-social-icons">
      <h5>Socials</h5>
        <ul class="social-icons">
          <li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
        </ul>
    </div>

    <div class="col-sm-12 text-center">
        <small>&copy; 2025 Crafttor. All rights reserved</small>
      </div>
  </div>
  </div>
</footer>
